import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Pencil, Trash2, Copy, CheckCircle } from 'lucide-react';

export const StudentCard = ({ student, className, copiedCode, onEdit, onDelete, onCopyCode }) => (
  <Card className="bg-card border-border card-hover">
    <CardContent className="p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <span className="text-lg font-bold text-primary">
            {student.name.charAt(0).toUpperCase()}
          </span>
        </div>
        <div className="flex gap-1">
          <Button variant="ghost" size="icon" onClick={() => onEdit(student)} className="h-8 w-8">
            <Pencil className="w-4 h-4" />
          </Button>
          <Button
            variant="ghost" size="icon"
            onClick={() => onDelete(student.student_id)}
            className="h-8 w-8 text-destructive hover:text-destructive"
          >
            <Trash2 className="w-4 h-4" />
          </Button>
        </div>
      </div>
      <h3 className="text-lg font-bold mb-1">{student.name}</h3>
      <p className="text-sm text-muted-foreground mb-3">{className}</p>
      <div
        className="flex items-center justify-between bg-muted/50 rounded-sm px-3 py-2 cursor-pointer hover:bg-muted transition-colors"
        onClick={() => onCopyCode(student.unique_code)}
        data-testid={`code-${student.student_id}`}
      >
        <span className="font-mono text-sm font-bold text-primary">{student.unique_code}</span>
        {copiedCode === student.unique_code ? (
          <CheckCircle className="w-4 h-4 text-green-500" />
        ) : (
          <Copy className="w-4 h-4 text-muted-foreground" />
        )}
      </div>
    </CardContent>
  </Card>
);
